import { z } from 'zod';

export const emailValidation = z
  .string()
  .min(1, 'Email is required')
  .email('Please enter a valid email');

export const passwordValidation = z
  .string()
  .refine((p) => /[\W_]/.test(p), {
    message: 'Password must have a special character',
  })
  .refine((p) => /\d/.test(p), { message: 'Password must have a number' })
  .refine((p) => /[A-Z]/.test(p), {
    message: 'Password must have an uppercase letter',
  })
  .refine((p) => /[a-z]/.test(p), {
    message: 'Password must have a lowercase letter',
  })
  .min(8, 'Password must have at least 8 characters')
  .min(1, 'Password is required');

export const checkboxValidation = z.boolean().optional();

export const agreementValidation = z.boolean().refine((val) => val === true, {
  message: 'Please accept our Terms and Conditions and Privacy policy to continue',
});
